import { CarouselBaseCard } from '@post-office/browser--growth-starburst/common/carouselBaseCard';

import {
	type CardImages,
	type CarouselCardProps,
} from '@post-office/browser--growth-starburst/common/carouselBaseCard/types';

import { commonTwcMessages } from '@post-office/browser--growth-starburst/common/constants';

import { defineMessages } from 'react-intl';

import { JiraCardIllustrationDark } from '../assets/JiraCardIllustrationDark';

import { JiraCardIllustrationLight } from '../assets/JiraCardIllustrationLight';

import { type JSX } from 'react/jsx-runtime';

export const JiraOnboardingCard = (props: CarouselCardProps): JSX.Element => {
	const images: CardImages = {
		component: <JiraCardIllustrationLight />,
		componentDark: <JiraCardIllustrationDark />,
	};

	return (
		<CarouselBaseCard
			messages={{ ...jiraMessages, ...commonTwcMessages }}
			images={images}
			{...props}
		/>
	);
};

const jiraMessages = defineMessages({
	heading: {
		defaultMessage: 'Plan out tasks with Jira',
		description: 'Heading for the Jira onboarding card',
		id: 'townsquare.twc-onboarding-widget.jira-card.heading',
	},

	description: {
		defaultMessage: 'Create project tasks to begin managing your project.',
		description: 'Description for the Jira onboarding card',
		id: 'townsquare.twc-onboarding-widget.jira-card.description',
	},

	cta: {
		defaultMessage: 'Try Jira',
		description: 'Call to action text for the Jira onboarding card',
		id: 'townsquare.twc-onboarding-widget.jira-card.cta',
	},
});
